module.exports = __webpack_public_path__ + "static/media/helpdesk.ccd1a3fb.png";